import { useEffect, useRef, useState } from "react";

import { MarketingNavBar } from "@/components/MarketingNavBar";
import { cn } from "@/lib/utils";

export function StickyNav({
  variant = "teal",
}: {
  variant?: "teal" | "orange" | "slate";
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [animation, setAnimation] = useState<"in" | "out" | "initial">(
    "initial",
  );

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isOffTopOfScreen = entry.boundingClientRect.top < 0;

        if (isOffTopOfScreen) {
          setAnimation("in");
        } else {
          setAnimation((c) => (c === "initial" ? "initial" : "out"));
        }
      });
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);

  return (
    <>
      <div
        className={cn(
          "fixed top-0 inset-x-0 z-50",
          variant === "teal" && "bg-teal-9 dark:bg-tealdark-9",
          variant === "orange" && "bg-orange-9 dark:bg-orangedark-9",
          variant === "slate" && "bg-slate-9 dark:bg-slatedark-9",
          animation === "initial" && "hidden",
          animation === "in" && "animate-in slide-in-from-top duration-300",
          animation === "out" &&
            "animate-out slide-out-to-top fill-mode-forwards duration-300",
        )}
      >
        <div className="container mx-auto px-8 py-4 md:px-12 flex flex-col gap-8 md:gap-16">
          <MarketingNavBar showStartButton variant={variant} />
        </div>
      </div>
      <div ref={ref} />
    </>
  );
}
